import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import CommissionReportsAPI from '../../api/commissionReports';
export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isFetchingMetrics: false,
  },
  meta: {
    count: 0,
    currentPage: 1,
  },
};

export const getters = {
  getAll(_state) {
    return _state.records;
  },
  getMeta(_state) {
    return _state.meta;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  get: async function getResponses({ commit }, params) {
    commit(types.SET_COMMISSION_REPORTS_UI_FLAG, { isFetching: true });
    try {
      const response = await CommissionReportsAPI.get(params);
      const { payload, meta } = response.data;

      commit(types.SET_COMMISSION_REPORTS, payload);
      commit(types.SET_COMMISSION_REPORTS_META, meta);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_COMMISSION_REPORTS_UI_FLAG, { isFetching: false });
    }
  },
};

export const mutations = {
  [types.SET_COMMISSION_REPORTS_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_COMMISSION_REPORTS]: MutationHelpers.set,
  [types.SET_COMMISSION_REPORTS_META](_state, { count, current_page: currentPage }) {
    _state.meta = {
      count,
      currentPage,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
